module.exports = __webpack_public_path__ + "static/img/no-data.1b48b5fd.png";